import React from "react"

import PropTypes from "prop-types"
import {Icon} from "semantic-ui-react"

import "./style.scss"

export const MESSAGE_ICON_VARIANT = {DEFAULT: "default", YELLOW: "yellow"}

const MessageIcon = ({children, className, icon, variant = MESSAGE_ICON_VARIANT.DEFAULT, ...props}) => (
    <div className={`message-icon variant-${variant} ${className ? className : ""}`} {...props}>
        {icon && (
            <div className="message-icon-icon">
                <Icon className={icon} />
            </div>
        )}
        <div className="message-icon-content">{children}</div>
    </div>
)

MessageIcon.propTypes = {
    children: PropTypes.node.isRequired,
    className: PropTypes.string,
    icon: PropTypes.string,
    variant: PropTypes.oneOf(Object.values(MESSAGE_ICON_VARIANT)),
}

export default MessageIcon
